import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';

import { Fitter } from '@sc/data-access-models';
import {
  SetFittersAction,
  SetResourcesAction,
} from './agenda-resources.actions';
import { Resource } from '../../models';

export const AgendaResourcesStateKey: Readonly<string> = 'agendaResources';
export const AgendaResourcesStateDefault: Readonly<AgendaResourcesStateObj> = {
  fitters: [],
  resources: [],
};

export interface AgendaResourcesStateObj {
  fitters: Fitter[];
  resources: Resource[];
}

@State<AgendaResourcesStateObj>({
  name: AgendaResourcesStateKey,
  defaults: AgendaResourcesStateDefault,
})
@Injectable()
export class AgendaResourcesState {
  @Action(SetFittersAction)
  setFitters(
    ctx: StateContext<AgendaResourcesStateObj>,
    { payload }: SetFittersAction
  ): void {
    ctx.setState({
      ...ctx.getState(),
      fitters: payload ?? [],
    });
  }

  @Action(SetResourcesAction)
  setResources(
    ctx: StateContext<AgendaResourcesStateObj>,
    { payload }: SetResourcesAction
  ): void {
    ctx.setState({
      ...ctx.getState(),
      resources: payload ?? [],
    });
  }
}
